"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DB_VERIFY_EMAIL_MISMATCH = exports.COGNITO_VERIFY_EMAIL_MISMATCH = exports.INVALID_ACCOUNT_NAME = exports.INVALID_EMAIL = exports.REQ_EXPIRED = exports.INVALID_SIG = exports.NO_SIG_FOUND = exports.NOT_AUTHENTICATED = exports.NO_AUTH_HEADER = exports.MISSING_IMPORT_INFO = exports.JSON_PARSE_FAILURE = exports.MAXED_OUT_CONNECTIONS = exports.DUPLICATE_INSERT = exports.MALFORMED_UUID = exports.CLIP_NOT_FOUND = exports.OVER_MAX_MEMBERS = exports.EXCEEDED_BATCH_INSERT_LIMIT = exports.SHARE_OBJECT_NOT_FOUND = exports.UNEXPECTED_SHARE_OBJECT_TYPE = exports.PARENT_BOARD_NOT_IN_WORKSPACE = exports.REEL_NOT_FOUND = exports.CLIP_NOT_IN_WORKSPACE = exports.NO_ACCOUNT_ERROR = exports.MEMBER_NOT_FOUND = exports.UNEXPECTED_SORT = exports.UNAUTHORIZED_INACTIVE_OBJECT_ACTION = exports.NO_LIBRARY_PERMISSION = exports.WORKSPACE_PERMISSION_FAILURE = exports.NO_WORKSPACE_PERMISSION = exports.NO_PERMISSION = exports.UNEXPECTED_BOARD_CONTEXT = exports.EMPTY_STRING_ERROR = exports.CLIP_CURSOR_DATE_RANGE_CONFLICT = exports.NO_BOARD_CLIP_PERMISSION = exports.NO_MORE_STORAGE = exports.INVALID_PRICING_MODEL = exports.INVALID_PLAN = exports.MISMATCHED_STRIPE_PLANS = exports.PLAN_NOT_FOUND = exports.MISSING_BILLING_CYCLE = exports.EXPIRED_STRIPE_COUPON = exports.NO_SUCH_STRIPE_COUPON = exports.MISSING_STRIPE_CARD = exports.MISSING_STRIPE_PLAN_ID = exports.MISSING_STRIPE_SUBSCRIPTION_ITEM = exports.STRIPE_SUBSCRIPTION_INVALID = exports.MISSING_STRIPE_SUBSCRIPTION_ID = exports.SUBSCRIPTION_CONVERSION_INVALID_PERMISSIONS = exports.SUBSCRIPTION_EXPIRED = exports.MISSING_ENV_VAR = void 0;
exports.DATABASE_QUERY_ERROR = exports.BAD_REQUEST = exports.VIEW_ID_WITHOUT_BOARD_ID = exports.MUST_MODIFY_SHARED_ASSET_CUSTOM_FIELDS = exports.MUST_MODIFY_DESCENDANT_BOARDS = exports.MUST_MODIFY_DESCENDANT_ASSETS = exports.INVALID_BOARD_ITEM_POSITION = exports.PARENT_BOARD_MISMATCH = exports.INVALID_ROLE = exports.INVALID_CUSTOM_FIELD_INPUT = exports.INVALID_ASSET_RESOLUTION = exports.INVALID_VISIBLE_FIELD = exports.INVALID_SORT_FIELD = exports.INVALID_VISIBLE_COLUMN = exports.INVALID_GROUP_BY = exports.NOT_FOUND = exports.LIBRARY_NOT_FOUND = exports.FORBIDDEN = exports.INVALID_COUNTRY_CODE = exports.INVALID_POSTAL_CODE = exports.SALES_TAX_CALCULATION_FAILED = exports.INVALID_BOARD_CLIP = exports.BOARD_CLIP_NOT_FOUND = exports.INVALID_API_KEY = exports.IMPORTER_FATAL_ERROR = exports.INVALID_IMPORT_SESSION = exports.INVALID_IMPORT_OPERATION = exports.INVALID_IMPORT_SOURCE = exports.NO_IMPORT_JOB = exports.NO_IMPORT_SESSION = exports.MORE_THAN_ONE_VERSION_REQUIRED_TO_EXTRACT = exports.SHORT_URL_EXPIRED = exports.SHORT_URL_DISABLED = exports.NO_SHARED_BOARD_PERMISSIONS = exports.CURSOR_AND_SORT_BY_MISMATCH = exports.CURSOR_AND_END_ITEM_BOTH_PROVIDED = exports.MISSING_OR_INVALID_SHORT_URL_TOKEN = exports.MISSING_OR_INVALID_SHORT_URL_PASSCODE = exports.INVALID_SHORTURL_UPDATE = exports.NO_CLIP_IMAGE_FOUND = exports.INVALID_BOORKMARK_OR_FAVORITE = exports.IDP_ACCOUNT_EXISTS = exports.FETCH_UNAUTHORIZED = exports.FAILED_TO_FETCH = exports.MISSING_REST_FIELD = exports.INVALID_DATE = exports.NO_COMMENT_PERMISSION = exports.INVALID_CHILD_BOARD = exports.INVALID_PARENT_BOARD = exports.UNEXPECTED_VERIFY_FORMAT = void 0;
exports.CUSTOM_FIELD_COLOR_NOT_FOUND = exports.THUMBNAIL_UPDATE_FAILED = exports.MEDIA_RECORD_NOT_FOUND = exports.INVALID_CLIP_TYPE = exports.IMAGE_TOO_LARGE = exports.MAX_FORM_SESSION_ITEMS_EXCEEDED = exports.URI_LENGTH_TOO_LONG = exports.BAD_GATEWAY = exports.THROTTLED = exports.REQUEST_TIMED_OUT = exports.SAML_INTEGRATION_NOT_FOUND = exports.WORKSPACE_EXISTS_IN_ORGANIZATION = exports.WORKSPACE_EXISTS_IN_ANOTHER_ORGANIZATION = exports.MAX_DOMAINS_REACHED = exports.DOMAIN_ALREADY_EXISTS = exports.MAX_ANCESTOR_COUNT_EXCEEDED = exports.INTERNAL_ERROR = exports.PROCESS_TIMED_OUT = exports.SOURCE_FILE_NOT_FOUND = exports.SOURCE_URL_INVALID = exports.SOURCE_URL_BLOCKED = exports.TOO_MANY_REQUESTS = exports.CONFLICT = exports.SESSION_EXPIRED = exports.API_KEY_LIMIT_EXCEEDED = exports.TAGS_MUST_BE_NON_EMPTY = exports.LAST_ADMIN_ERROR = exports.LIBRARY_TITLE_EXISTS = exports.INVALID_INPUT = exports.LIBRARY_MISMATCH_IN_PARENT_BOARD = exports.LIBRARY_REQUIRES_AN_OWNER = exports.BOARD_NOT_IN_LIBRARY = exports.ACCOUNT_ALREADY_MEMBER = exports.INVALID_FIELD_VALUE = exports.INPUT_FIELD_TOO_LONG = exports.MISSING_REQUIRED_INPUT_FIELD = exports.SLACK_INTEGRATION_CONFLICT = exports.WORKSPACE_NOT_FOUND = exports.WORKSPACE_INTEGRATION_SSO_NOT_ENABLED = exports.WORKSPACE_INTEGRATION_PROVIDER_NOT_FOUND = exports.WORKSPACE_INTEGRATION_NOT_FOUND = exports.SAML_METADATA_LOOKUP_ERROR = void 0;
exports.MISSING_ENV_VAR = {
    type: 'MISSING_ENV_VAR',
    message: 'Missing environment variable',
    statusCode: 500,
};
exports.SUBSCRIPTION_EXPIRED = {
    type: 'SUBSCRIPTION_EXPIRED',
    message: 'Subscription has expired',
    statusCode: 403,
};
exports.SUBSCRIPTION_CONVERSION_INVALID_PERMISSIONS = {
    type: 'SUBSCRIPTION_CONVERSION_INVALID_PERMISSIONS',
    message: `You do not have the permissions required to change this workspace's plan to that subscription.`,
    statusCode: 403,
};
exports.MISSING_STRIPE_SUBSCRIPTION_ID = {
    type: 'MISSING_STRIPE_SUBSCRIPTION_ID',
    message: 'Stripe subscription ID could not be found',
    statusCode: 404,
};
exports.STRIPE_SUBSCRIPTION_INVALID = {
    type: 'STRIPE_SUBSCRIPTION_INVALID',
    message: 'Stripe subscription is invalid for this operation',
    statusCode: 400,
};
exports.MISSING_STRIPE_SUBSCRIPTION_ITEM = {
    type: 'MISSING_STRIPE_SUBSCRIPTION_ITEM',
    message: 'Stripe subscription item could not be found',
    statusCode: 404,
};
exports.MISSING_STRIPE_PLAN_ID = {
    type: 'MISSING_STRIPE_PLAN_ID',
    message: 'Stripe plan ID could not be found',
    statusCode: 404,
};
exports.MISSING_STRIPE_CARD = {
    type: 'MISSING_STRIPE_CARD',
    message: 'Stripe card could not be found',
    statusCode: 404,
};
exports.NO_SUCH_STRIPE_COUPON = {
    type: 'NO_SUCH_STRIPE_COUPON',
    message: 'Coupon does not exist',
    statusCode: 404,
};
exports.EXPIRED_STRIPE_COUPON = {
    type: 'EXPIRED_STRIPE_COUPON',
    message: 'Coupon has expired or maxed out redemptions',
    statusCode: 400,
};
exports.MISSING_BILLING_CYCLE = {
    type: 'MISSING_BILLING_CYCLE',
    message: 'Billing cycle is not set',
    statusCode: 400,
};
exports.PLAN_NOT_FOUND = {
    type: 'PLAN_NOT_FOUND',
    message: 'Plan pricing could not be found',
    statusCode: 404,
};
exports.MISMATCHED_STRIPE_PLANS = {
    type: 'MISMATCHED_STRIPE_PLANS',
    message: 'Plan in database does not match plan in Stripe',
};
exports.INVALID_PLAN = {
    type: 'INVALID_PLAN',
    message: 'Plan not valid for this operation',
    statusCode: 400,
};
exports.INVALID_PRICING_MODEL = {
    type: 'INVALID_PRICING_MODEL',
    message: 'The provided pricing model is invalid',
    statusCode: 400,
};
exports.NO_MORE_STORAGE = {
    type: 'NO_MORE_STORAGE',
    message: 'Workspace storage is full',
    statusCode: 409,
};
exports.NO_BOARD_CLIP_PERMISSION = {
    type: 'NO_BOARD_CLIP_PERMISSION',
    message: 'No permission to access board clips',
    statusCode: 403,
};
exports.CLIP_CURSOR_DATE_RANGE_CONFLICT = {
    type: 'CLIP_CURSOR_DATE_RANGE_CONFLICT',
    message: 'Cursor conflicts with startDate and endDate range',
    statusCode: 400,
};
exports.EMPTY_STRING_ERROR = {
    type: 'EMPTY_STRING_ERROR',
    message: 'Cannot add empty string',
    statusCode: 400,
};
exports.UNEXPECTED_BOARD_CONTEXT = {
    type: 'UNEXPECTED_BOARD_CONTEXT',
    message: 'Unexpected board context in header',
    statusCode: 400,
};
exports.NO_PERMISSION = {
    type: 'NO_PERMISSION',
    message: 'No permission',
    extra: [],
    statusCode: 403,
};
exports.NO_WORKSPACE_PERMISSION = {
    type: 'NO_WORKSPACE_PERMISSION',
    message: 'No workspace permission',
    statusCode: 403,
};
exports.WORKSPACE_PERMISSION_FAILURE = {
    type: 'WORKSPACE_PERMISSION_FAILURE',
    message: 'Workspace permission checking failed',
    statusCode: 403,
};
exports.NO_LIBRARY_PERMISSION = {
    type: 'NO_LIBRARY_PERMISSION',
    message: 'No library permission',
    statusCode: 403,
};
exports.UNAUTHORIZED_INACTIVE_OBJECT_ACTION = {
    type: 'UNAUTHORIZED_INACTIVE_OBJECT_ACTION',
    message: 'Action not allowed on inactive object',
    statusCode: 403,
};
exports.UNEXPECTED_SORT = {
    type: 'UNEXPECTED_SORT',
    message: 'Unexpected sort type',
    statusCode: 400,
};
exports.MEMBER_NOT_FOUND = {
    type: 'MEMBER_NOT_FOUND',
    message: 'Workspace member not found.',
    statusCode: 404,
};
exports.NO_ACCOUNT_ERROR = {
    type: 'NO_ACCOUNT_ERROR',
    message: 'Account does not exist',
    statusCode: 404,
};
exports.CLIP_NOT_IN_WORKSPACE = {
    type: 'CLIP_NOT_IN_WORKSPACE',
    message: 'Clip(s) not in workspace',
    statusCode: 404,
};
exports.REEL_NOT_FOUND = {
    type: 'REEL_NOT_FOUND',
    message: 'Board does not exist',
    statusCode: 404,
};
exports.PARENT_BOARD_NOT_IN_WORKSPACE = {
    type: 'PARENT_BOARD_NOT_IN_WORKSPACE',
    message: 'Specified parent board is not in workspace',
    statusCode: 409,
};
exports.UNEXPECTED_SHARE_OBJECT_TYPE = {
    type: 'UNEXPECTED_SHARE_OBJECT_TYPE',
    message: 'Unexpected share object type',
    statusCode: 400,
};
exports.SHARE_OBJECT_NOT_FOUND = {
    type: 'SHARE_OBJECT_NOT_FOUND',
    message: 'Share object not found',
    statusCode: 404,
};
exports.EXCEEDED_BATCH_INSERT_LIMIT = {
    type: 'EXCEEDED_BATCH_INSERT_LIMIT',
    message: 'Exceeded maximum number of objects to insert at once.',
    statusCode: 400,
};
exports.OVER_MAX_MEMBERS = {
    type: 'OVER_MAX_MEMBERS',
    message: 'Exceeds maximum number of members for workspace',
    statusCode: 400,
};
exports.CLIP_NOT_FOUND = {
    type: 'CLIP_NOT_FOUND',
    message: 'Clip does not exist',
    statusCode: 404,
};
exports.MALFORMED_UUID = {
    type: 'MALFORMED_UUID',
    message: 'Invalid syntax for UUID',
    statusCode: 400,
};
exports.DUPLICATE_INSERT = {
    type: 'DUPLICATE_INSERT',
    message: 'An item with this ID has already been inserted',
    statusCode: 409,
};
exports.MAXED_OUT_CONNECTIONS = {
    type: 'MAXED_OUT_CONNECTIONS',
    message: 'Database has maxed out its connections',
    statusCode: 503,
};
exports.JSON_PARSE_FAILURE = {
    type: 'JSON_PARSE_FAILURE',
    message: 'Failed to parse JSON',
    statusCode: 400,
};
exports.MISSING_IMPORT_INFO = {
    type: 'MISSING_IMPORT_INFO',
    message: 'Missing field for import job',
    statusCode: 404,
};
exports.NO_AUTH_HEADER = {
    type: 'NO_AUTH_HEADER',
    message: 'Missing authorization header',
};
exports.NOT_AUTHENTICATED = {
    type: 'NOT_AUTHENTICATED',
    message: 'Not authenticated',
    statusCode: 401,
};
exports.NO_SIG_FOUND = {
    type: 'NO_SIG_FOUND',
    message: 'No encryption signature found',
    statusCode: 400,
};
exports.INVALID_SIG = {
    type: 'INVALID_SIG',
    message: 'Invalid encryption signature',
    statusCode: 400,
};
exports.REQ_EXPIRED = {
    type: 'REQ_EXPIRED',
    message: 'Request has expired',
    statusCode: 400,
};
exports.INVALID_EMAIL = {
    type: 'INVALID_EMAIL',
    message: 'Not a valid email',
    statusCode: 400,
};
exports.INVALID_ACCOUNT_NAME = {
    type: 'INVALID_ACCOUNT_NAME',
    message: 'Invalid account name',
    statusCode: 400,
};
exports.COGNITO_VERIFY_EMAIL_MISMATCH = {
    type: 'COGNITO_VERIFY_EMAIL_MISMATCH',
    message: 'The current cognito email for the user does not match the email indicated by the verify link.',
    statusCode: 400,
};
exports.DB_VERIFY_EMAIL_MISMATCH = {
    type: 'DB_VERIFY_EMAIL_MISMATCH',
    message: 'The current database email for the user does not match the email indicated by the verify link.',
    statusCode: 400,
};
exports.UNEXPECTED_VERIFY_FORMAT = {
    type: 'UNEXPECTED_VERIFY_FORMAT',
    message: 'Could not decode the given input',
    statusCode: 400,
};
exports.INVALID_PARENT_BOARD = {
    type: 'INVALID_PARENT_BOARD',
    message: 'Invalid parent board',
    statusCode: 400,
};
exports.INVALID_CHILD_BOARD = {
    type: 'INVALID_CHILD_BOARD',
    message: 'Not a child board',
    statusCode: 400,
};
exports.NO_COMMENT_PERMISSION = {
    type: 'NO_COMMENT_PERMISSION',
    message: 'No comment permission',
    statusCode: 403,
};
exports.INVALID_DATE = {
    type: 'INVALID_DATE',
    message: 'Date is invalid',
    statusCode: 400,
};
exports.MISSING_REST_FIELD = {
    type: 'MISSING_REST_FIELD',
    message: 'Missing REST param',
    statusCode: 400,
};
exports.FAILED_TO_FETCH = {
    type: 'FAILED_TO_FETCH',
    message: 'Failed to fetch',
};
exports.FETCH_UNAUTHORIZED = {
    type: 'FETCH_UNAUTHORIZED',
    message: 'Fetch authentication failed',
};
exports.IDP_ACCOUNT_EXISTS = {
    type: 'IDP_ACCOUNT_EXISTS',
    message: 'IdP Account Exists',
};
exports.INVALID_BOORKMARK_OR_FAVORITE = {
    type: 'INVALID_BOORKMARK_OR_FAVORITE',
    message: 'Cannot bookmark clip or favorite board for another member.',
    statusCode: 400,
};
exports.NO_CLIP_IMAGE_FOUND = {
    type: 'NO_CLIP_IMAGE_FOUND',
    message: 'No clip image found',
    statusCode: 404,
};
exports.INVALID_SHORTURL_UPDATE = {
    type: 'INVALID_SHORTURL_UPDATE',
    message: 'Invalid shorturl update',
    statusCode: 400,
};
exports.MISSING_OR_INVALID_SHORT_URL_PASSCODE = {
    type: 'MISSING_OR_INVALID_SHORT_URL_PASSCODE',
    message: 'Share object id and passcode mismatch',
    statusCode: 403,
};
exports.MISSING_OR_INVALID_SHORT_URL_TOKEN = {
    type: 'MISSING_OR_INVALID_SHORT_URL_TOKEN',
    message: 'Missing or invalid token for passcode protected shared object',
    statusCode: 400,
};
exports.CURSOR_AND_END_ITEM_BOTH_PROVIDED = {
    type: 'CURSOR_AND_END_ITEM_BOTH_PROVIDED',
    message: 'Both cursor and item to move before provided, only one should be present',
    statusCode: 400,
};
exports.CURSOR_AND_SORT_BY_MISMATCH = {
    type: 'CURSOR_AND_SORT_BY_MISMATCH',
    message: 'The cursor does not match the sort.',
    statusCode: 400,
};
exports.NO_SHARED_BOARD_PERMISSIONS = {
    type: 'NO_SHARED_BOARD_PERMISSIONS',
    message: 'Insufficient shared board permission to perform action',
    statusCode: 403,
};
exports.SHORT_URL_DISABLED = {
    type: 'SHORT_URL_DISABLED',
    message: 'The short url is disabled',
    statusCode: 403,
};
exports.SHORT_URL_EXPIRED = {
    type: 'SHORT_URL_EXPIRED',
    message: 'The short url has expired',
    statusCode: 403,
};
exports.MORE_THAN_ONE_VERSION_REQUIRED_TO_EXTRACT = {
    type: 'MORE_THAN_ONE_VERSION_TO_EXTRACT',
    message: 'Asset must have more than one asset-version in order to extract',
    statusCode: 400,
};
exports.NO_IMPORT_SESSION = {
    type: 'NO_IMPORT_SESSION',
    message: 'Client must authenticate with the third-party service.',
    statusCode: 404,
};
exports.NO_IMPORT_JOB = {
    type: 'NO_IMPORT_JOB',
    message: 'Job Id must be a valid import Id.',
    statusCode: 404,
};
exports.INVALID_IMPORT_SOURCE = {
    type: 'INVALID_IMPORT_SOURCE',
    message: 'Invalid import source provided.',
    statusCode: 400,
};
exports.INVALID_IMPORT_OPERATION = {
    type: 'INVALID_IMPORT_OPERATION',
    message: 'Invalid import operation requested.',
    statusCode: 400,
};
exports.INVALID_IMPORT_SESSION = {
    type: 'INVALID_IMPORT_SESSION',
    message: 'Invalid import session.',
    statusCode: 400,
    extra: {
        reason: '',
    },
};
exports.IMPORTER_FATAL_ERROR = {
    type: 'IMPORTER_FATAL_ERROR',
    message: 'Fatal error',
};
exports.INVALID_API_KEY = {
    type: 'INVALID_API_KEY',
    message: 'Invalid import api key provided.',
    statusCode: 403,
};
exports.BOARD_CLIP_NOT_FOUND = {
    type: 'BOARD_CLIP_NOT_FOUND',
    message: 'Board clip not found',
    statusCode: 404,
};
exports.INVALID_BOARD_CLIP = {
    type: 'INVALID_BOARD_CLIP',
    message: 'Board clip is invalid',
    statusCode: 400,
};
exports.SALES_TAX_CALCULATION_FAILED = {
    type: 'SALES_TAX_CALCULATION_FAILED',
    message: 'Sales tax calculation failed',
    statusCode: 500,
};
exports.INVALID_POSTAL_CODE = {
    type: 'INVALID_POSTAL_CODE',
    message: 'The postal code provided is invalid',
    statusCode: 400,
};
exports.INVALID_COUNTRY_CODE = {
    type: 'INVALID_COUNTRY_CODE',
    message: 'The country code provided is invalid',
    statusCode: 400,
};
exports.FORBIDDEN = {
    type: 'FORBIDDEN',
    message: 'You do not have permission to perform the requested action.',
    statusCode: 403,
};
exports.LIBRARY_NOT_FOUND = {
    type: 'LIBRARY_NOT_FOUND',
    message: 'The requested library does not exist.',
    statusCode: 404,
};
exports.NOT_FOUND = {
    type: 'NOT_FOUND',
    message: 'The requested resource does not exist.',
    statusCode: 404,
};
exports.INVALID_GROUP_BY = {
    type: 'INVALID_GROUP_BY',
    message: 'The provided groupBy is invalid.',
    statusCode: 400,
};
exports.INVALID_VISIBLE_COLUMN = {
    type: 'INVALID_VISIBLE_COLUMN',
    message: 'A provided visible column is invalid.',
    statusCode: 400,
};
exports.INVALID_SORT_FIELD = {
    type: 'INVALID_SORT_FIELD',
    message: 'A provided sort field is invalid.',
    statusCode: 400,
};
exports.INVALID_VISIBLE_FIELD = {
    type: 'INVALID_VISIBLE_FIELD',
    message: 'A provided visible field is invalid.',
    statusCode: 400,
};
exports.INVALID_ASSET_RESOLUTION = {
    type: 'INVALID_ASSET_RESOLUTION',
    message: 'The requested resolution does not exist for the specified asset.',
    statusCode: 400,
};
exports.INVALID_CUSTOM_FIELD_INPUT = {
    type: 'INVALID_CUSTOM_FIELD_INPUT',
    message: 'The provided custom field inputs are invalid.',
    statusCode: 400,
};
exports.INVALID_ROLE = {
    type: 'INVALID_ROLE',
    message: 'The provided role is invalid.',
    statusCode: 400,
};
exports.PARENT_BOARD_MISMATCH = {
    type: 'PARENT_BOARD_MISMATCH',
    message: 'The items associated with this operation do not have matching parent boards',
    statusCode: 400,
};
exports.INVALID_BOARD_ITEM_POSITION = {
    type: 'INVALID_BOARD_ITEM_POSITION',
    message: 'The position of the moveAfterBoardItem is less than the position of the moveBeforeBoardItem.',
    statusCode: 400,
};
exports.MUST_MODIFY_DESCENDANT_ASSETS = {
    type: 'MUST_MODIFY_DESCENDANT_ASSETS',
    message: 'can only modify assets that are descendants of the shared board',
    statusCode: 403,
};
exports.MUST_MODIFY_DESCENDANT_BOARDS = {
    type: 'MUST_MODIFY_DESCENDANT_BOARDS',
    message: 'can only modify boards that are descendants of the shared board',
    statusCode: 403,
};
exports.MUST_MODIFY_SHARED_ASSET_CUSTOM_FIELDS = {
    type: 'MUST_MODIFY_SHARED_ASSET_CUSTOM_FIELDS',
    message: 'can only modify customfields on the shared asset',
    statusCode: 403,
};
exports.VIEW_ID_WITHOUT_BOARD_ID = {
    type: 'VIEW_ID_WITHOUT_BOARD_ID',
    message: 'boardId missing from request with viewId',
    statusCode: 400,
};
exports.BAD_REQUEST = {
    type: 'BAD_REQUEST',
    message: 'Bad request',
    statusCode: 400,
    extra: {
        constraints: [],
    },
};
exports.DATABASE_QUERY_ERROR = {
    type: 'DATABASE_QUERY_ERROR',
    message: 'There was an error completing the database query.',
    statusCode: 500,
};
exports.SAML_METADATA_LOOKUP_ERROR = {
    type: 'SAML_METADATA_LOOKUP_ERROR',
    message: 'There was an error verifying metadata url',
    statusCode: 422,
};
exports.WORKSPACE_INTEGRATION_NOT_FOUND = {
    type: 'WORKSPACE_INTEGRATION_NOT_FOUND',
    message: 'Workspace Integration Not Found',
    statusCode: 404,
};
exports.WORKSPACE_INTEGRATION_PROVIDER_NOT_FOUND = {
    type: 'WORKSPACE_INTEGRATION_PROVIDER_NOT_FOUND',
    message: 'Workspace Integration Provider Not Found',
    statusCode: 404,
};
exports.WORKSPACE_INTEGRATION_SSO_NOT_ENABLED = {
    type: 'WORKSPACE_INTEGRATION_SSO_NOT_ENABLED',
    message: 'SSO is not enabled for this email address',
    statusCode: 422,
};
exports.WORKSPACE_NOT_FOUND = {
    type: 'WORKSPACE_NOT_FOUND',
    message: 'Workspace not found',
    statusCode: 404,
};
exports.SLACK_INTEGRATION_CONFLICT = {
    type: 'SLACK_INTEGRATION_CONFLICT',
    message: 'There already exists a Slack integration to a different Slack workspace',
    statusCode: 400,
};
exports.MISSING_REQUIRED_INPUT_FIELD = {
    type: 'MISSING_REQUIRED_INPUT_FIELD',
    message: 'Missing required input field',
    statusCode: 400,
};
exports.INPUT_FIELD_TOO_LONG = {
    type: 'INPUT_FIELD_TOO_LONG',
    message: 'Input field too long',
    statusCode: 400,
};
exports.INVALID_FIELD_VALUE = {
    type: 'INVALID_FIELD_VALUE',
    message: 'Invalid input field value',
    statusCode: 400,
};
exports.ACCOUNT_ALREADY_MEMBER = {
    type: 'ACCOUNT_ALREADY_MEMBER',
    message: 'Account is already a member',
    statusCode: 409,
};
exports.BOARD_NOT_IN_LIBRARY = {
    type: 'BOARD_NOT_IN_LIBRARY',
    message: 'Specified board is not in library',
    statusCode: 409,
};
exports.LIBRARY_REQUIRES_AN_OWNER = {
    type: 'LIBRARY_REQUIRES_AN_OWNER',
    message: 'Library requires at least one owner',
    statusCode: 409,
};
exports.LIBRARY_MISMATCH_IN_PARENT_BOARD = {
    type: 'LIBRARY_MISMATCH_IN_PARENT_BOARD',
    message: 'Library mismatch with parent board',
    statusCode: 409,
};
exports.INVALID_INPUT = {
    type: 'INVALID_INPUT',
    message: 'Invalid input',
    statusCode: 400,
};
exports.LIBRARY_TITLE_EXISTS = {
    type: 'LIBRARY_TITLE_EXISTS',
    message: 'Library with this name already exists',
    statusCode: 409,
};
exports.LAST_ADMIN_ERROR = {
    type: 'LAST_ADMIN_ERROR',
    message: 'Removing the workspace last admin is not allowed',
    statusCode: 403,
};
exports.TAGS_MUST_BE_NON_EMPTY = {
    type: 'TAGS_MUST_BE_NON_EMPTY',
    message: 'Tags must be non-empty strings',
    statusCode: 400,
};
exports.API_KEY_LIMIT_EXCEEDED = {
    type: 'API_KEY_LIMIT_EXCEEDED',
    message: `You have reached the maximum number of API keys`,
    statusCode: 400,
};
exports.SESSION_EXPIRED = {
    type: 'SESSION_EXPIRED',
    message: 'Session expired',
    statusCode: 401,
};
exports.CONFLICT = {
    type: 'CONFLICT',
    message: 'Conflict',
    statusCode: 409,
};
exports.TOO_MANY_REQUESTS = {
    type: 'TOO_MANY_REQUESTS',
    message: 'Too Many Requests',
    statusCode: 429,
};
exports.SOURCE_URL_BLOCKED = {
    type: 'SOURCE_URL_BLOCKED',
    message: 'Source URL is blocked',
    statusCode: 400,
};
exports.SOURCE_URL_INVALID = {
    type: 'SOURCE_URL_INVALID',
    message: 'The source URL is not accessible or invalid',
    statusCode: 400,
};
exports.SOURCE_FILE_NOT_FOUND = {
    type: 'SOURCE_FILE_NOT_FOUND',
    message: 'Source file not found',
    statusCode: 400,
};
exports.PROCESS_TIMED_OUT = {
    type: 'PROCESS_TIMED_OUT',
    message: 'Process timed out',
};
exports.INTERNAL_ERROR = {
    type: 'INTERNAL_ERROR',
    message: 'Internal error',
    statusCode: 500,
};
exports.MAX_ANCESTOR_COUNT_EXCEEDED = {
    type: 'MAX_ANCESTOR_COUNT_EXCEEDED',
    message: 'Maximum number of allowed ancestors exceeded',
    statusCode: 409,
};
exports.DOMAIN_ALREADY_EXISTS = {
    type: 'DOMAIN_ALREADY_EXISTS',
    message: 'Domain already exits',
    statusCode: 409,
};
exports.MAX_DOMAINS_REACHED = {
    type: 'MAX_DOMAINS_REACHED',
    message: 'Maximum number of domains reached',
    statusCode: 409,
};
exports.WORKSPACE_EXISTS_IN_ANOTHER_ORGANIZATION = {
    type: 'WORKSPACE_EXISTS_IN_ANOTHER_ORGANIZATION',
    message: 'Workspace already exits in another organization',
    statusCode: 409,
};
exports.WORKSPACE_EXISTS_IN_ORGANIZATION = {
    type: 'WORKSPACE_EXISTS_IN_ORGANIZATION',
    message: 'Workspace already exits in organization',
    statusCode: 409,
};
exports.SAML_INTEGRATION_NOT_FOUND = {
    type: 'SAML_INTEGRATION_NOT_FOUND',
    message: 'SAML integration not found for the organization',
    statusCode: 404,
};
exports.REQUEST_TIMED_OUT = {
    type: 'REQUEST_TIMED_OUT',
    message: 'Request timed out',
    statusCode: 408,
};
exports.THROTTLED = {
    type: 'THROTTLED',
    message: 'Throttled',
    statusCode: 429,
};
exports.BAD_GATEWAY = {
    type: 'BAD_GATEWAY',
    message: 'Bad Gateway',
    statusCode: 502,
};
exports.URI_LENGTH_TOO_LONG = {
    type: 'URI_LENGTH_TOO_LONG',
    message: 'URI length too long',
    statusCode: 414,
};
exports.MAX_FORM_SESSION_ITEMS_EXCEEDED = {
    type: 'MAX_FORM_SESSION_ITEMS_EXCEEDED',
    message: 'Maximum number of allowed form session items exceeded',
    statusCode: 409,
};
exports.IMAGE_TOO_LARGE = {
    type: 'IMAGE_TOO_LARGE',
    message: 'Thumbnail image is too large',
    statusCode: 400,
};
exports.INVALID_CLIP_TYPE = {
    type: 'INVALID_CLIP_TYPE',
    message: 'Clip must be a video',
    statusCode: 400,
};
exports.MEDIA_RECORD_NOT_FOUND = {
    type: 'MEDIA_RECORD_NOT_FOUND',
    message: 'Media record not found',
    statusCode: 400,
};
exports.THUMBNAIL_UPDATE_FAILED = {
    type: 'THUMBNAIL_UPDATE_FAILED',
    message: 'Failed to update thumbnail',
    statusCode: 400,
};
exports.CUSTOM_FIELD_COLOR_NOT_FOUND = {
    type: 'CUSTOM_FIELD_COLOR_NOT_FOUND',
    message: 'Custom field color not found',
    statusCode: 400,
};
//# sourceMappingURL=errors.js.map